var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8558 39C29.2695 39 37.7115 30.2696 37.7115 19.5C37.7115 8.73045 29.2695 0 18.8558 0C8.44201 0 0 8.73045 0 19.5C0 30.2696 8.44201 39 18.8558 39Z",
    fill: "#272EAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0171 30.5674V21.1386H13.7598V17.3917H17.0171V14.4396C17.0171 11.2321 19.0385 9.48633 21.9901 9.48633C23.4042 9.48633 24.6188 9.58926 24.9713 9.63455V12.9861H22.9243C21.3191 12.9861 21.009 13.7272 21.009 14.8101V17.3917H24.6316L24.1347 21.1386H21.009V30.5674",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 12,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0171 30.5674V21.1386H13.7598V17.3917H17.0171V14.4396C17.0171 11.2321 19.0385 9.48633 21.9901 9.48633C23.4042 9.48633 24.6188 9.58926 24.9713 9.63455V12.9861H22.9243C21.3191 12.9861 21.009 13.7272 21.009 14.8101V17.3917H24.6316L24.1347 21.1386H21.009V30.5674",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_92)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a56d33e773ed9d8a506526fc0be33935.svg";
export { ForwardRef as ReactComponent };